/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_MessageInputs */

const en_feedback_message = /** @type {(inputs: Feedback_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should we improve?`)
};

const id_feedback_message = /** @type {(inputs: Feedback_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang perlu diperbaiki?`)
};

/**
* | output |
* | --- |
* | "What should we improve?" |
*
* @param {Feedback_MessageInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const feedback_message = /** @type {((inputs?: Feedback_MessageInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_MessageInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_feedback_message(inputs)
	return en_feedback_message(inputs)
});